import { useMemo } from "react";
import { useFetcher } from "~/hooks/useFetcher";
import { projectSkillsPath } from "~/services/projects";
import { PartialSkill, SkillPage } from "~/services/skills";

interface UseSkillsResult {
  skills: PartialSkill[];
  isLoading: boolean;
}

// A conversation's skills are a pure function of its project (whose datasets
// resolve the DATASET scope) and its agent (the AGENT scope), so both the New
// Session splash and a live conversation fetch them the same way — keyed on
// `(projectId, agentId)`, never on a conversation id. The conversations-service
// resolves the project's attached datasets and returns the deduped USER + AGENT
// + DATASET union the orchestrator injects; the frontend owns no recipe and no
// client-side dedup. Skips the fetch until a project id is known; re-keys when
// the agent changes.
export function useSkills(
  projectId: string | null | undefined,
  agentId: string | null | undefined
): UseSkillsResult {
  const key = projectId ? projectSkillsPath(projectId, agentId) : null;
  const { data, isLoading } = useFetcher<SkillPage>(key);

  const skills = useMemo(
    () => [...(data?.items ?? [])].sort((a, b) => a.name.localeCompare(b.name)),
    [data]
  );

  return { skills, isLoading };
}
